export interface KanbanViewHeaderI {
    title: string;
    day: string;
    jobs: string;
    pieces: string;
    hours: string;
    scheduleDate: string;
    position: number;
    dropOff: string;
    dropOffHour: string;
}

export interface KanbanViewCardI {
    select: boolean;
    id: string;
    customerName: string;
    job: string;
    order: string;
    type: string;
    product: string;
    image: string;
    dueDate: string;
    machineId: string;
    machineName: string;
    scheduleDate: string;
    status: string;
    quantity: string;
    pinned: boolean;
    statusId: string;
    statusName: string;
    batchMaster: number;
    batchJobs?: any[];
}

export interface KanbanViewListI {
    id: string;
    header: KanbanViewHeaderI,
    cards: KanbanViewCardI[];
}
